import http from "../core/http";
const group = 'notifications';

export const getNotificationsRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const markAllAsReadRequest =  async (data) => {
    return await http.post(`${group}/markAllAsRead`, data).then(res => res.data).catch(http.defaultCatch);
}